import * as actions from './actions'

const module = { actions }

export default { module }
